/* eslint-disable @typescript-eslint/naming-convention */
import { Components } from '@mui/material';
import { Theme as MuiTheme } from '@mui/material/styles';
 

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    neutral: true;
    green: true;
    primaryDark: true;
  }

  interface ButtonPropsVariantOverrides {
    link: true;
  }
}

export const button: Components['MuiButton'] = {
  variants: [
    {
      props: { variant: 'link', color: 'primaryDark' },
      style: ({ theme }) => ({
        color: (theme as MuiTheme).palette.primaryDark.main,
        fontFamily: 'Lato',
        textDecoration: 'underline',
        '&:hover': {
          color: (theme as MuiTheme).palette.primaryDark.dark,
          background: 'none',
          textDecoration: 'underline',
        },
      }),
    },
  ],
  styleOverrides: {
    root: ({ theme }) => ({
      fontFamily: 'Gotham',
      textTransform: 'none',
      fontWeight: 'bold',
      fontSize: (theme as MuiTheme).typography.pxToRem(14),
      lineHeight: (theme as MuiTheme).typography.pxToRem(18),
      padding: `${(theme as MuiTheme).typography.pxToRem(11)} ${(
        theme as MuiTheme
      ).typography.pxToRem(16)}`,
      letterSpacing: (theme as MuiTheme).typography.pxToRem(0.16),
      '&.Mui-disabled': {
        color: (theme as MuiTheme).palette.text.disabled,
      },
    }),
    outlined: ({ theme }) => ({
      background: (theme as MuiTheme).palette.background.paper,
      borderColor: 'inherit',
    }),
    text: {
      fontWeight: 'normal',
      fontFamily: 'Lato',
      '&.Mui-disabled': {
        fontFamily: 'Lato',
      },
    },
    sizeLarge: ({ theme }) => ({
      fontSize: (theme as MuiTheme).typography.pxToRem(16),
    }),
  },
  defaultProps: {
    variant: 'outlined',
    disableElevation: true,
    disableRipple: true,
    color: 'primaryDark',
  },
};
